<div
    class="border-b border-solid border-black border-opacity-10 bg-grey-white_smoke dark:bg-contrast-black"
    *ngIf="
        env.PURCHASE_FLOW?.SHOW_USER_ACCOUNT_CHOICE &&
        (isAuthenticated$ | async) &&
        (allAccountDataLoading$ | async) === false &&
        (accountsWithDisplayData$ | async)?.length > 1
    ">
    <div class="flex w-full bg-white px-4 py-2">
        <div class="mx-auto w-full" *ngIf="uiState$ | async as uiState">
            <ng-container *ngIf="isAuthenticated$ | async">
                <!-- Show account selector only when all data is loaded -->
                <ng-container *ngIf="(allAccountDataLoading$ | async) === false">
                    <!-- Ionic Segment Control for 2 options -->
                    <ion-segment
                        class="ios-segment flex rounded-lg border-solid dark:border-contrast-yellow"
                        *ngIf="uiState.showSegment"
                        [(ngModel)]="uiState.selectedAccountId"
                        [swipeGesture]="true"
                        (ionChange)="onAccountChange($event.detail.value)"
                        mode="ios">
                        <ion-segment-button
                            class="ios-segment-button"
                            *ngFor="let account of accountsWithDisplayData$ | async; trackBy: trackById"
                            [value]="account.id"
                            [disabled]="!account.isActive">
                            <div class="flex min-w-0 max-w-full flex-1 gap-x-1 overflow-visible">
                                <ng-container
                                    *ngTemplateOutlet="
                                        accountIconWrapper;
                                        context: {
                                            iconType: account.isNonPersonal ? 'corporate' : 'personal',
                                            isSelected: uiState.selectedAccountId === account.id
                                        }
                                    "></ng-container>
                                <!-- Word break styles in component scss -->
                                <ion-label class="flex items-center gap-2">
                                    <span [class.line-through]="!account.isActive">
                                        <!-- For non-personal accounts with organization, show organization name -->
                                        <span *ngIf="account.isNonPersonal && account.organization">
                                            {{ account.organization.name }}
                                        </span>

                                        <!-- For personal accounts or when organization is not available, use account type-->
                                        <span *ngIf="!account.isNonPersonal || !account.organization">
                                            {{ account.name | translateObjectField: null : locale : account.typeCode }}
                                        </span>
                                    </span>
                                    <ion-icon
                                        class="text-primary-danger h-4 w-4 dark:text-contrast-yellow"
                                        *ngIf="!account.isActive"
                                        [src]="(assetsPath$ | async) + '/img/purchase-flow-v2/areas/blocked.svg'">
                                    </ion-icon>
                                </ion-label>
                            </div>
                        </ion-segment-button>
                    </ion-segment>

                    <!-- Material Button for 3+ options -->
                    <button
                        class="account-selector-button !border-1 h-14 !rounded-lg border-solid bg-white !px-6 dark:!border-contrast-yellow"
                        *ngIf="uiState.showDialog"
                        (click)="openAccountDialog()"
                        mat-stroked-button>
                        <div class="left-content">
                            <ion-icon
                                class="text-gray-zambezy h-8 w-8 font-bold dark:text-contrast-yellow"
                                *ngIf="selectedAccountWithDisplayData$ | async"
                                [src]="
                                    (assetsPath$ | async) +
                                    '/img/purchase-flow-v2/areas/' +
                                    ((selectedAccountWithDisplayData$ | async)?.typeCode === 'PERSONAL'
                                        ? 'personal'
                                        : 'corporate') +
                                    '.svg'
                                ">
                            </ion-icon>
                            <span class="text-gray-zambezy text-base font-bold">
                                <!-- For non-personal accounts with organization, show organization name -->
                                <span
                                    *ngIf="
                                        (selectedAccountWithDisplayData$ | async)?.isNonPersonal &&
                                        (selectedAccountWithDisplayData$ | async)?.organization
                                    ">
                                    {{ (selectedAccountWithDisplayData$ | async)?.organization.name }}
                                </span>

                                <!-- For personal accounts or when organization is not available, use translate pipe -->
                                <span
                                    *ngIf="
                                        !(selectedAccountWithDisplayData$ | async)?.isNonPersonal ||
                                        !(selectedAccountWithDisplayData$ | async)?.organization
                                    ">
                                    {{
                                        (selectedAccountWithDisplayData$ | async)?.name
                                            | translateObjectField
                                                : null
                                                : locale
                                                : (selectedAccountWithDisplayData$ | async)?.typeCode ||
                                                      ('SELECT_ACCOUNT' | translate)
                                    }}
                                </span>
                            </span>
                        </div>
                        <ion-icon
                            class="text-gray-zambezy h-8 w-8"
                            [src]="(assetsPath$ | async) + '/img/purchase-flow-v2/areas/chevron_down.svg'">
                        </ion-icon>
                    </button>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #accountIconWrapper let-iconType="iconType" let-isSelected="isSelected">
    <span class="flex items-center">
        <ion-icon
            class="text-gray-zambezy h-8 w-8"
            [ngClass]="{
                'dark:text-contrast-black': isSelected,
                'dark:text-contrast-yellow': !isSelected
            }"
            [src]="(assetsPath$ | async) + '/img/purchase-flow-v2/areas/' + iconType + '.svg'">
        </ion-icon>
    </span>
</ng-template>
